import React from "react";
import { DataEntryForm } from "../components/data-entry/DataEntryForm";

const PartnerData = () => {
  return <DataEntryForm />;
};

export default PartnerData;
